import React from 'react';
import {
  Box,
  Container,
  Spinner,
  Text,
  VStack,
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";

const LoadingPage = () => {
  // Dynamic colors based on color mode
  const spinnerColor = useColorModeValue("blue.500", "blue.200");
  const bgGradient = useColorModeValue(
    "var(--gradient-auth)",
    "var(--gradient-auth)"
  );
  const textColor = useColorModeValue("var(--color-text-light)", "gray.200");
  const headingColor = useColorModeValue(
    "linear(to-r, blue.500, purple.500)",
    "linear(to-r, blue.300, purple.300)"
  );

  return (
    <Box
      /* Ensure full viewport coverage to avoid white gaps below gradient */
      minH="100vh"
      bg={bgGradient}
      py={16}
      position="relative"
      overflow="hidden"
      display="flex"
      alignItems="center"
    >
      {/* Abstract background elements */}
      <Box position="absolute" top="-100px" left="-50px" w="300px" h="300px" borderRadius="full" bg={useColorModeValue("blue.100", "blue.900")} opacity="0.3" filter="blur(70px)" />
      <Box position="absolute" bottom="-100px" right="-50px" w="350px" h="350px" borderRadius="full" bg={useColorModeValue("purple.100", "purple.900")} opacity="0.3" filter="blur(70px)" />
    
      <Container maxW="container.xl" position="relative" zIndex={1}>
        <VStack spacing={10} textAlign="center">
          <Heading
            as="h1"
            size="xl"
            fontWeight="bold"
            bgGradient={headingColor}
            bgClip="text"
            mb={2}
          >
            Loading Your Experience
          </Heading>
          
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color={spinnerColor}
            size="xl"
          />
          
          <Text
            fontSize="lg"
            fontWeight="medium"
            color={textColor}
            letterSpacing="wide"
            maxW="md"
          >
            Please wait while we prepare your personalized learning environment...
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default LoadingPage;
